import { Stack, Text, Divider } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';

import { SectionStack } from '../components';

import type { JudgeResult } from '../../../types';

interface JudgeEducationProps {
  judgeData: JudgeResult;
}

export const JudgeEducation = ({ judgeData }: JudgeEducationProps) => {
  const { isMobile } = useScreenSize();

  return (
    <SectionStack sx={{ mt: 2 }}>
      <Stack spacing={isMobile ? 1 : 2}>
        <Text variant="h5">Education History</Text>
        {isMobile && <Divider />}
        <Stack spacing={1}>
          {judgeData.educations?.length > 0 ? (
            judgeData.educations.map((education, index) => (
              <Text key={index}>
                {`${
                  education.school.name
                    ? `Attended ${education.school.name}`
                    : ''
                }
                  ${
                    education.degree_detail || education.degree_level
                      ? `${education.school.name ? ' and' : ''}
                  ${education.school.name ? 'r' : 'R'}eceived a ${
                          education.degree_detail ||
                          education.degree_level.toUpperCase()
                        }`
                      : ''
                  }
                  ${
                    education.degree_year &&
                    (education.school.name ||
                      education.degree_detail ||
                      education.degree_level)
                      ? ` in ${education.degree_year}`
                      : ''
                  }`}
              </Text>
            ))
          ) : (
            <Text>No education history available</Text>
          )}
        </Stack>
      </Stack>
    </SectionStack>
  );
};
